import { useConfig } from '../contexts/ConfigContext'
import { useAuth } from './useAuth'

export const NOTHING_ENABLED_PATH = '/nothing-enabled'

interface LandingInputs {
    contribute?: boolean
    ask?: boolean
    captures?: boolean
    engage?: boolean
    communityHub?: boolean
    isAnonymous: boolean
    anonymousPageAccess: { chat: boolean; community: boolean }
}

/**
 * The first page this user can open, in the agreed order: Contribute, Ask,
 * Captures, Engage, Community. Each check mirrors that page's route wrapper in
 * index.tsx, so a page never redirects to one that would redirect it back.
 */
export function landingPath({
    contribute,
    ask,
    captures,
    engage,
    communityHub,
    isAnonymous,
    anonymousPageAccess,
}: LandingInputs): string {
    if (contribute) return '/contribute'
    if (ask && (!isAnonymous || anonymousPageAccess.chat)) return '/'
    if (captures && !isAnonymous) return '/captures'
    if (engage) return '/engage'
    if (communityHub && (!isAnonymous || anonymousPageAccess.community)) {
        return '/community'
    }
    return NOTHING_ENABLED_PATH
}

export function useLandingPath(): string {
    const config = useConfig()
    const { isAnonymous } = useAuth()

    return landingPath({ ...config, isAnonymous })
}
